// extracted by mini-css-extract-plugin
module.exports = {"container":"countryTitle__container___1OLle"};